// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PorterStoreIcons from "../../../porter-store/view/components/PorterStoreIcons.bs.js";

function GstinCard$HeaderActionButton(Props) {
  var className = Props.className;
  var label = Props.label;
  var onClick = Props.onClick;
  var children = Props.children;
  return React.createElement("button", {
              "aria-label": label,
              className: className,
              title: label,
              type: "button",
              onClick: (function ($$event) {
                  $$event.stopPropagation();
                  return Curry._1(onClick, undefined);
                })
            }, children);
}

var HeaderActionButton = {
  make: GstinCard$HeaderActionButton
};

function GstinCard(Props) {
  var gstinValue = Props.gstinValue;
  var companyName = Props.companyName;
  var companyAddress = Props.companyAddress;
  var addedOn = Props.addedOn;
  var onDelete = Props.onDelete;
  var onUndo = Props.onUndo;
  var isStruckOut = Props.isStruckOut;
  var canDelete = Props.canDelete;
  var match = React.useState(function () {
        return false;
      });
  var setIsExpanded = match[1];
  var isExpanded = match[0];
  var numberClassName = "gstin-card__number" + (
    isExpanded ? " gstin-card__number--bold" : ""
  ) + (
    isStruckOut ? " gstin-card__number--deleted" : ""
  );
  return React.createElement("div", {
              className: isExpanded ? "gstin-card gstin-card--expanded" : "gstin-card"
            }, React.createElement("div", {
                  className: "gstin-card__header",
                  onClick: (function (param) {
                      return Curry._1(setIsExpanded, (function (prev) {
                                    return !prev;
                                  }));
                    })
                }, React.createElement("span", {
                      className: numberClassName
                    }, gstinValue !== "" ? gstinValue : "No GSTIN"), React.createElement("div", {
                      className: "gstin-card__header-right"
                    }, addedOn !== "" ? React.createElement("span", {
                            className: "gstin-card__date"
                          }, "Added on " + addedOn) : null, React.createElement("div", {
                          className: "gstin-card__toggle"
                        }, React.createElement("span", {
                              className: "gstin-card__toggle-text"
                            }, isExpanded ? "Hide Details" : "See Details"), React.createElement("span", {
                              className: isExpanded ? "gstin-card__chevron gstin-card__chevron--up" : "gstin-card__chevron"
                            }, React.createElement(PorterStoreIcons.SizeChevron.make, {}))), canDelete ? (
                        isStruckOut ? React.createElement(GstinCard$HeaderActionButton, {
                                className: "gstin-card__undo",
                                label: "Undo delete",
                                onClick: onUndo,
                                children: "Undo"
                              }) : React.createElement(GstinCard$HeaderActionButton, {
                                className: "gstin-card__delete",
                                label: "Delete GSTIN",
                                onClick: onDelete,
                                children: React.createElement(PorterStoreIcons.Delete.make, {})
                              })
                      ) : null)), React.createElement("div", {
                  className: isExpanded ? "gstin-card__expandable gstin-card__expandable--open" : "gstin-card__expandable"
                }, React.createElement("div", {
                      className: "gstin-card__expandable-inner"
                    }, React.createElement("div", {
                          className: "gstin-card__divider"
                        }), React.createElement("div", {
                          className: "gstin-card__details"
                        }, React.createElement("div", {
                              className: "gstin-card__row"
                            }, React.createElement("div", {
                                  className: "gstin-card__field"
                                }, React.createElement("span", {
                                      className: "gstin-card__label"
                                    }, "GSTIN"), React.createElement("div", {
                                      className: "gstin-card__input"
                                    }, React.createElement("input", {
                                          className: "gstin-card__input-field",
                                          disabled: true,
                                          type: "text",
                                          value: gstinValue
                                        }))), React.createElement("div", {
                                  className: "gstin-card__field"
                                }, React.createElement("span", {
                                      className: "gstin-card__label"
                                    }, "Company Name"), React.createElement("div", {
                                      className: "gstin-card__input"
                                    }, React.createElement("input", {
                                          className: "gstin-card__input-field",
                                          disabled: true,
                                          type: "text",
                                          value: companyName
                                        })))), React.createElement("div", {
                              className: "gstin-card__field gstin-card__field--full"
                            }, React.createElement("span", {
                                  className: "gstin-card__label"
                                }, "Company Address"), React.createElement("div", {
                                  className: "gstin-card__input"
                                }, React.createElement("input", {
                                      className: "gstin-card__input-field",
                                      disabled: true,
                                      type: "text",
                                      value: companyAddress
                                    })))))));
}

var make = GstinCard;

export {
  HeaderActionButton ,
  make ,
  
}
/* react Not a pure module */
